import { Message } from 'rsuite'
import useTranslation from '@/hooks/useTranslation'
import ShowVinInfoModal from './showVinInfoModal'
import QRCode from './qrCode'

import { useState } from 'react'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'

import { customerHelper } from '@tweddle-se-team/common/constants'
import { configSelectors } from '@/store/configs'

import styles from './footerMessage.module.scss'

const { CUSTOMER_IDS } = customerHelper

const PPWR_URL = 'https://www.toyota-europe.com/sustainability/compliance/ppwr'
const PPWR_TITLE_FALLBACK = 'Packaging and Packaging Waste Regulation (PPWR) information:'
const PPWR_SCAN_FALLBACK = 'Please scan the QR code below for PPWR-related information.'

// PPWR is a TME (Toyota + Lexus) regulatory requirement - not shown for Subaru.
const PPWR_ENABLED_BY_CUSTOMER = {
  [CUSTOMER_IDS.TME]: true,
  [CUSTOMER_IDS.SUBARU]: false
}

const FooterMessage = ({ brand }) => {
  const [showVinInfoModal, setShowVinInfoModal] = useState(false)
  const t = useTranslation()
  const router = useRouter()
  const customerId = useSelector(configSelectors.selectCustomerId)
  const showPpwr = Boolean(PPWR_ENABLED_BY_CUSTOMER[customerId])
  return (
    <>
      <Message>
        <div>
          <p>
            {t('content_footer_content_line_1')}.<br />
            {t('content_footer_content_line_2')}.
          </p>
          <div className="cursorpointer">
            <span
              onClick={() => router.push(`/?brand=${brand}#enterVIN`)}
              role="button"
              tabIndex={0}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  router.push(`/?brand=${brand}#enterVIN`)
                }
              }}
            >
              <u>{t('content_footer_search_by_vin')}</u>
            </span>
          </div>
          <p>
            <span
              style={{ textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => setShowVinInfoModal(true)}
              role="button"
              tabIndex={0}
              onKeyDown={e => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  setShowVinInfoModal(true)
                }
              }}
            >
              {t('content_footer_vin_location')}
            </span>
          </p>
          {showPpwr && (
            <div className={styles.ppwr}>
              <p className={styles.ppwrTitle}>{t('content_footer_ppwr_title', PPWR_TITLE_FALLBACK)}</p>
              <div className={styles.ppwrRow}>
                <div
                  className={styles.qrWrapper}
                  role="img"
                  aria-label="QR code linking to PPWR compliance information"
                >
                  <QRCode value={PPWR_URL} width={120} />
                </div>
                <div className={styles.ppwrText}>
                  <p>{t('content_footer_ppwr_scan_instruction', PPWR_SCAN_FALLBACK)}</p>
                  <a className={styles.ppwrLink} href={PPWR_URL} target="_blank" rel="noopener noreferrer">
                    {PPWR_URL}
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </Message>
      <ShowVinInfoModal show={showVinInfoModal} onHide={() => setShowVinInfoModal(false)} />
    </>
  )
}

export default FooterMessage
